(function($) {

	$.fn.msxiSelect = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.msxiSelect.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            updateSelectClass($this);
            $this.change(function() {
                updateSelectClass($this);
            });
            $this.keypress(function() {
                updateSelectClass($this);
            });

            /*$this.mousedown(function() {
                $this.removeClass('default-option');
            });*/
        });
	};
	//
	// plugin defaults
	//
	$.fn.msxiSelect.defaults = {
	};
    //
    // Private functions
    //
    function updateSelectClass($this){
        if ($this.find("option:selected").hasClass('default-option')) {
            $this.addClass('default-option');
        }
        else {
            $this.removeClass('default-option');
        }
    }

})(jQuery);